'use strict';

import React, { Fragment } from 'react';

import QuickSearchBase from './QuickSearchBase';
import ExtendSearch from '../ExtendSearch/RentCommercials';
import { RENT, COMMERCIALS } from '../../../consts';
import { Checkbox } from '../../Controls';

class RentCommercials extends QuickSearchBase {
  render () {
    return (
      <Fragment>
        <div className='flex flex-items-center quick-search-rent-commercials'>
          { this.renderObjectType(RENT, COMMERCIALS) }
          { this.renderTerritorialDivision() }
          { this.renderAutocompleteLocation() }
          { this.renderPriceGroup(true) }

          { this.renderExtendSearch(ExtendSearch) }

        </div>

        <div className='flex flex-items-center quick-search__sub-filter'>
          <div className='quick-search__sub-filter-left'>
            <Checkbox
              label='Частные объявления'
              checked={this.getValue('onlyOwners')}
              onUpdate={this.handlerCheckbox('onlyOwners')}
            />

            <Checkbox
              label='С фото'
              checked={this.getValue('hasPhoto')}
              onUpdate={this.handlerCheckbox('hasPhoto')}
            />
          </div>
          <div className='quick-search__sub-filter-right'>
            { this.renderSubmitMap() }
            { this.renderSubmit() }
          </div>
        </div>

        { this.renderPills(RENT, COMMERCIALS) }
      </Fragment>
    );
  }
}

export default RentCommercials;



// WEBPACK FOOTER //
// ./src/ui/Search/QuickSearch/RentCommercials.jsx